export const clientStatusCheck = (clientStatus, statusToCompare) =>
  clientStatus === statusToCompare;
